// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import loading from "./components/Loading.vue"; //import loading component
import guide from "./components/Guide.vue"; //import guide component
import "./plugins/vuetify-money.js";
import VueBarcode from "vue-barcode";
import tools from "@persian-tools/vue-persian-tools";

// Gravatar
const Gravatar = () => import("vue-gravatar");

Vue.use(tools, {
  components: true,
  directives: true,
});

Vue.component("v-gravatar", Gravatar);
// VueClipboard
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

import Notifications from "vue-notification";
Vue.use(Notifications);
import CKEditor from "@ckeditor/ckeditor5-vue";

Vue.use(CKEditor);
// Vue.use('vue-shortkey', { prevent: ['input', 'textarea', 'v-text-field', 'v-textarea'] })
Vue.use(require("vue-shortkey"), {
  prevent: ["input", "textarea", "v-text-field", "v-textarea"],
});
import velocity from "velocity-animate";
Vue.use(Notifications, { velocity });

import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

import VueSpinners from "vue-spinners";
Vue.use(VueSpinners);

// cssVars()

Vue.use(BootstrapVue);

import vuetify from "@/plugins/vuetify"; // path to vuetify export

import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css",
    "https://stackpath.bootstrapcdn.com/bootstrap/5.0.0-alpha2/css/bootstrap.min.css",
    "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.19.0/bootstrap-vue-icons.min.css",
    "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.19.0/bootstrap-vue.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    // '/print.css' //css stylings should be add to this file in public folder
  ],
};
Vue.use(VueHtmlToPaper, options);

// export const baseUrl = "https://baas.ppk.satr.app"; // Also declared in socketConnecton.js
export const baseUrl = "https://ppkbaas.satrapp.com"; // Also declared in socketConnecton.js
// export const baseUrl = "http://192.168.1.20:3002";
// export const baseUrl = "http://localhost:4000";

//repeated data and methods imported here
Vue.mixin({
  components: { loading, guide },
  data() {
    return {
      baseUrl: baseUrl,
      //baseUrl:"http://192.168.1.9:3002",
      vLoading: false,
      vGuide: false,
    };
  },
  methods: {
    validateEmail(email) {
      if (email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      } else return true;
    },
    toast(message, type) {
      this.$toast[type](message, {
        position: type == "success" ? "top-left" : "top-center",
        icon: false,
        closeButton: false,
        timeout: type == "error" ? 15000 : 3000,
      });
    },
    checkCodeMeli(code) {
      if (code) {
        var L = code.length;

        if (L < 8 || parseInt(code, 10) == 0) return false;
        code = ("0000" + code).substr(L + 4 - 10);
        if (parseInt(code.substr(3, 6), 10) == 0) return false;
        var c = parseInt(code.substr(9, 1), 10);
        var s = 0;
        for (var i = 0; i < 9; i++)
          s += parseInt(code.substr(i, 1), 10) * (10 - i);
        s = s % 11;
        return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
        return true;
      } else return true;
    },
    doEncrypt(value) {
      const secret_key = "abcdefg";
      const secret_iv = "hijk";
      const encryptionMethod = "AES-256-CBC";
      let key = crypto
        .createHash("sha512")
        .update(secret_key, "utf-8")
        .digest("hex")
        .substr(0, 32);
      let iv = crypto
        .createHash("sha512")
        .update(secret_iv, "utf-8")
        .digest("hex")
        .substr(0, 16);
      let encryptor = crypto.createCipheriv(encryptionMethod, key, iv);
      let aes_encrypted =
        encryptor.update(value, "utf8", "base64") + encryptor.final("base64");
      let result = Buffer.from(aes_encrypted).toString("base64");
      return result;
    },
    doDecrypt(value) {
      let buff = Buffer.from(value, "base64");
      hash = buff.toString("utf-8");
      let key = Crypto.createHash("sha512")
        .update("abcdefg", "utf-8")
        .digest("hex")
        .substring(0, 32);
      let iv = Crypto.createHash("sha512")
        .update("hijk", "utf-8")
        .digest("hex")
        .substring(0, 16);
      let decryptor = Crypto.createDecipheriv("aes-256-cbc", key, iv);
      return decryptor.update(hash, "base64", "utf8") + decryptor.final("utf8");
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  data: {
    // url: 'http://pm.sarmadbs.com/',
    // token: '6aad0847cc2ce0f4c4cb512c98be2a0a12c307ce'
  },
  router,
  template: "<App/>",
  components: {
    App,
  },
  vuetify,
  mounted() {
    // if (window.localStorage.api_key === undefined) {
    // window.location = '/#/pages/login'
    // this.router.go('/pages/login')
    // router.push({ name: 'Login' })
    //return
    // }
  },
});
